// noinspection RedundantIfStatementJS

import type {FirebaseError} from 'firebase/app';

export function isFirebaseError(error: unknown): error is FirebaseError {
    if (error && typeof error === 'object' && 'name' in error && error.name === 'FirebaseError') {
        return true;
    } else {
        return false
    }
}